import { toast } from 'react-toastify';

/**
 * Handles API error responses and shows toast notifications for each error message.
 * @param {object} error - The error object from an API call (axios or similar).
 * @param {string} [fallbackMessage] - Optional fallback message if no details or message is found.
 */
export function showApiErrors(error, fallbackMessage = 'An error occurred, please try again') {
  const details = error?.response?.data?.details;
  if (Array.isArray(details)) {
    details.forEach((msg) => toast.error(msg));
  } else {
    toast.error(error?.response?.data?.message || fallbackMessage);
  }
} 